(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HeroB"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mw-hero-banner')) {
    class MwHeroBanner extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.mw-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.mw-hero__dot'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.delay = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay =
          this.dataset.autoplay === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => { this.go(parseInt(dot.dataset.dot, 10)); this.restart(); })
        );

        // Pause while the shopper hovers or uses the keyboard inside the banner
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        // Swipe on mobile
        this.addEventListener('touchstart', (e) => { this.touchX = e.touches[0].clientX; this.stop(); }, { passive: true });
        this.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - (this.touchX || 0);
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          this.start();
        }, { passive: true });

        // Theme editor: jump to the slide being edited
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.editing = true; this.go(i); this.stop(); }
        });
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.start(); });

        this.start();
      }

      disconnectedCallback() { this.stop(); }

      go(i) {
        const total = this.slides.length;
        this.index = (i + total) % total;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, n) => {
          const active = n === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.editing) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }

      stop() { clearInterval(this.timer); }

      restart() { this.stop(); this.start(); }
    }
    customElements.define('mw-hero-banner', MwHeroBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
